import type { ClassValue } from 'clsx';
import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['body-sm', 'body-md', 'body-lg', 'header-sm', 'header-md', 'header-lg', 'header-xl', 'header-2xl'] }],
    },
  },
});

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

type RecursiveKeyValuePair<K extends keyof any = string, V = string> = {
  [key: string]: V | RecursiveKeyValuePair<K, V>;
};

export type TailwindColorScaleDefinition = RecursiveKeyValuePair<string, string>;

export type TailwindColorsDefinition = Record<
  string,
  TailwindColorScaleDefinition
>;
